import store from '@/store'
import { ChatUtil } from '@/utils/Chat'

export const ChatHelper = {
  getChatBasket(basket) {
    return {
      persons: getChatPersons(basket),
      basketDetails: {
        location: basket.address,
        contractStartDate: basket.contractStartDate,
        collectiveContractNumber: basket.collective?.contractNumber
      }
    }
  }
}

function getChatProducts(person) {
  const products = person.products?.products || {}

  return Object.values(products)
    .filter(product => !!product.selected)
    .map(product => {
      const productId = product.id
      const categoryId = store.getters['products/getCategoryIdFromProduct'](productId)
      const price = product.prices.find(price => price.selected)

      return {
        criteria: ChatUtil.getChatProductCriteria(person, product, price),
        group: categoryId, // $t(`content.categories.${categoryId}.title`),
        productName: productId, // $t(`content.products.${productId}.name`),
        price: price.price
      }
    })
}

function getChatPersons(basket) {
  const persons = store.getters['basket/getPersons']
  return persons?.map(person => {
    return {
      firstName: person.personData.firstName,
      dateOfBirth: person.personData.dateOfBirth,
      gender: person.personData.gender,
      personGroup: person?.collectivePersonGroup,
      products: getChatProducts(person)
    }
  })
}
